import axios from "axios";

// 获取全局的 axios 实例
let axiosInstance = null;

// 这个方法需要在 Vue 应用初始化后调用
export function setAxiosInstance2(axios) {
  axiosInstance = axios;
}

// ========== 试卷管理接口 ==========

// 创建试卷
export function saveExam(data) {
  console.log('调用 saveExam，数据:', data)
  
  return axiosInstance({
    url: '/exam/create',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem("token")}`
    }
  }).then(response => {
    console.log('saveExam 响应:', response.data)
    return response.data
  }).catch(error => {
    console.error('saveExam 错误:', error.response)
    throw error
  })
}

// 更新试卷
export function updateExam(examId, data) {
  return axiosInstance({
    url: '/exam/update',
    method: 'put',
    data: {
      ...data,
      exam_id: examId
    }
  }).then(response => {
    return response.data
  }).catch(error => {
    console.error('updateExam 错误:', error.response)
    throw error
  })
}

// 获取试卷详情
export function getExamDetail(examId) {
  return axiosInstance({
    url: `/exam/detail?exam_id=${examId}`,
    method: 'get'
  }).then(response => {
    return response.data
  }).catch(error => {
    console.error('getExamDetail 错误:', error.response)
    throw error
  })
}

// 获取试卷完整详情
export function getExamFullDetail(examId) {
  return axiosInstance({
    url: `/exam/full-detail?exam_id=${examId}`,
    method: 'get'
  }).then(response => {
    return response.data
  }).catch(error => {
    console.error('getExamFullDetail 错误:', error.response)
    throw error
  })
}

// 获取试卷列表
export function getExamList(params = {}) {
  return axiosInstance({
    url: '/exam/list',
    method: 'get',
    params: {
      title: params.title || '',
      status: params.status,
      page: params.page || 1,
      size: params.size || 10,
      created_by_username: params.username || undefined
    }
  }).then(response => {
    return response.data
  }).catch(error => {
    console.error('getExamList 错误:', error.response)
    throw error
  })
}

// ========== 试卷题目管理接口 ==========

// 获取试卷题目列表
export function getExamQuestions(examId) {
  return axiosInstance({
    url: `/exam/questions?exam_id=${examId}`,
    method: 'get'
  }).then(response => {
    return response.data
  }).catch(error => {
    console.error('getExamQuestions 错误:', error.response)
    throw error
  })
}

// 添加题目到试卷
export function addQuestionToExam(examId, data) {
  return axiosInstance({
    url: `/exam/add-questions?exam_id=${examId}`,
    method: 'post',
    data: data
  }).then(response => {
    return response.data
  }).catch(error => {
    console.error('addQuestionToExam 错误:', error.response)
    throw error
  })
}

function getCurrentUsername() {
  // 从 Vuex store 获取用户信息
  const store = require('@/store').default
  return store.state.User?.username || ''
}

// 删除试卷题目
export function deleteExamQuestion(examId, questionId) {
  return axiosInstance({
    url: `/exam/delete-question`,
    method: 'delete',
    data: {
      exam_id: examId,
      question_id: questionId,
      username: getCurrentUsername()
    }
  }).then(response => {
    return response.data
  }).catch(error => {
    console.error('deleteExamQuestion 错误:', error.response)
    throw error
  })
}

// 删除试卷题目
export function deleteExamPaper(examId) {
  return axiosInstance({
    url: `/exam/delete-exam-paper?exam_id=${examId}`,
    method: 'delete',
  }).then(response => {
    return response.data
  }).catch(error => {
    console.error('deleteExamPaper 错误:', error.response)
    throw error
  })
}

// 重新排序题目
export function reorderQuestions(examId, questionIds) {
  return axiosInstance({
    url: `/exam/reorder-questions`,
    method: 'post',
    data: {
      exam_id: examId,
      question_ids: questionIds,
      username: getCurrentUsername()
    }
  }).then(response => {
    return response.data
  }).catch(error => {
    console.error('reorderQuestions 错误:', error.response)
    throw error
  })
}

// 发布试卷
export function publishExam(examId) {
  return axiosInstance({
    url: `/exam/publish`,
    method: 'put',
    data: {
      exam_id: examId,
      status: 1
    }
  }).then(response => {
    return response.data
  }).catch(error => {
    console.error('publishExam 错误:', error.response)
    throw error
  })
}

// 结束试卷
export function endExam(examId) {
  return axiosInstance({
    url: `/exam/end`,
    method: 'put',
    data: {
      exam_id: examId,
      status: 2
    }
  }).then(response => {
    return response.data
  }).catch(error => {
    console.error('publishExam 错误:', error.response)
    throw error
  })
}

// 复制试卷
export function copyExam(data) {
  return axiosInstance({
    url: '/exam/copy',
    method: 'post',
    data
  })
}
// ========== 题目搜索接口 ==========

// 获取常规填空题
export function getRegularQuestions(params = {}) {
  const { keyword = '', difficulty = '', knowledge = '' } = params;
  
  return axiosInstance({
    url: '/exam/regular-questions',
    method: 'get',
    params: {
      keyword: keyword || '',
      difficulty: difficulty || '',
      knowledge: knowledge || ''
    }
  }).then(response => {
    return response.data
  }).catch(error => {
    console.error('getRegularQuestions 错误:', error.response)
    throw error
  })
}

// 获取随机参数填空题
export function getRandomQuestions(params = {}) {
  const { keyword = '', difficulty = '', knowledge = '' } = params;
  
  return axiosInstance({
    url: '/exam/random-questions',
    method: 'get',
    params: {
      keyword: keyword || '',
      difficulty: difficulty || '',
      knowledge: knowledge || ''  // 添加知识点参数
    }
  }).then(response => {
    return response.data
  }).catch(error => {
    console.error('getRandomQuestions 错误:', error.response)
    throw error
  })
}

// 获取常规填空题详情
export function getRegularQuestionDetail(questionId) {
  return axiosInstance({
    url: `/exam/regular-question-detail?question_id=${questionId}`,
    method: 'get'
  }).then(response => {
    return response.data
  }).catch(error => {
    console.error('getRegularQuestionDetail 错误:', error.response)
    throw error
  })
}

// 获取随机参数填空题详情
export function getRandomQuestionDetail(questionId) {
  return axiosInstance({
    url: `/exam/random-question-detail?question_id=${questionId}`,
    method: 'get'
  }).then(response => {
    return response.data
  }).catch(error => {
    console.error('getRandomQuestionDetail 错误:', error.response)
    throw error
  })
}

export function getExamPreview(examId, refreshParams = false) {
  return axiosInstance({
    url: `/exam/preview?exam_id=${examId}`,
    method: 'get',
    params: {
      refresh_params: refreshParams
    }
  }).then(response => {
    return response.data
  }).catch(error => {
    console.error('getExamPreview 错误:', error.response)
    throw error
  })
}